import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// react query
import { QueryClient, QueryClientProvider } from 'react-query';

// custom toast
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={new QueryClient()}>
    <App />
    <ToastContainer />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
